export default defineNuxtPlugin(() => {
    const id = useRuntimeConfig().public.gaMeasurementId
    if (!id) return
    const s = document.createElement('script')
    s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    document.head.appendChild(s)
    window.dataLayer = (window as any).dataLayer || []
    function gtag(){ (window as any).dataLayer.push(arguments) }
    ;(window as any).gtag = gtag
    gtag('js', new Date()); gtag('config', id)
  })
  